import { useDailyChallenges } from '../../hooks/useOffline';
import type { Problem } from '../../types';
import './DailyChallenge.css';

interface DailyChallengeProps {
  onSelectProblem: (id: string) => void;
}

export function DailyChallenge({ onSelectProblem }: DailyChallengeProps) {
  const { daily, isLoading, error, retry } = useDailyChallenges();

  if (isLoading) {
    return <div className="daily-loading">Loading daily challenges...</div>;
  }

  if (!daily) {
    return (
      <div className="daily-empty">
        <p>{error ? `Error: ${error}` : 'No daily challenges available.'}</p>
        <button className="btn btn-retry" onClick={retry} style={{ marginTop: 12 }}>
          Retry
        </button>
      </div>
    );
  }

  const { problems, progress } = daily;
  const easy = problems.filter(p => p.difficulty <= 3);
  const medium = problems.filter(p => p.difficulty > 3 && p.difficulty <= 6);
  const hard = problems.filter(p => p.difficulty > 6);

  return (
    <div className="daily-challenge">
      <div className="daily-header">
        <h2>Daily Challenge</h2>
        <span className="daily-date">{daily.date}</span>
      </div>

      <div className="daily-progress">
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${(progress.solved / progress.total) * 100}%` }}
          />
        </div>
        <span className="progress-text">{progress.solved}/{progress.total}</span>
      </div>

      <DifficultySection title="Easy" problems={easy} color="#16a34a" onSelect={onSelectProblem} />
      <DifficultySection title="Medium" problems={medium} color="#d97706" onSelect={onSelectProblem} />
      <DifficultySection title="Hard" problems={hard} color="#dc2626" onSelect={onSelectProblem} />
    </div>
  );
}

function DifficultySection({ title, problems, color, onSelect }: {
  title: string; problems: Problem[]; color: string; onSelect: (id: string) => void;
}) {
  return (
    <div className="difficulty-section">
      <h3 style={{ color }}>{title}</h3>
      <div className="problem-grid">
        {problems.map((p, i) => (
          <button
            key={p.id}
            className="daily-problem-btn"
            onClick={() => onSelect(p.id)}
          >
            #{i + 1}
          </button>
        ))}
      </div>
    </div>
  );
}
